import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	bioTextArea: {
		minHeight: 80,
	},
	container: {
		position: 'relative',
	},
	footer: {
		alignItems: 'center',
		background: THEME.colors.background.light,
		boxSizing: 'border-box',
		display: 'flex',
		gap: THEME.spacing.sm,
		paddingBottom: 30,
		paddingTop: 30,
	},
	title: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		marginBottom: 30,
		textTransform: 'uppercase',
	},
});
